import { useState, useEffect } from 'react';
import { Input } from '~/components/common/forms';
import useDebounce from '~/utils/useDebounce';
import { SearchIcon } from '~/svgs';
const Search = ({ onSearch, placeholder }: any) => {
   const [searchValue, setSearchValue] = useState('');

   const debouncedValue = useDebounce(searchValue, 500);
   useEffect(() => {
      onSearch(debouncedValue);
   }, [debouncedValue, onSearch]);
   return (
      <Input
         onChange={(e: any) => setSearchValue(e.target.value)}
         className="ltr:!border-l-0 rtl:!border-r-0 rtl:!border-l"
         inputWrapperClassName="[&>*]:hover:border-primary"
         placeholder={placeholder}
         prependClassName="!bg-white"
         prepend={<SearchIcon className="w-8 " />}
      />
   );
};

export default Search;
